import * as React from 'react';
import { useState } from 'react';

interface IKeywordsProps {
    keywords: any[];
    initialDisplayCount?: number;
}

const Keywords: React.FC<IKeywordsProps> = ({
    keywords, 
    initialDisplayCount = 10
}) => {
    const [showAll, setShowAll] = useState(false);
    
    const displayedKeywords = React.useMemo(() => {
        if (!keywords?.length) return [];
        return showAll ? keywords : keywords.slice(0, initialDisplayCount);
    }, [keywords, showAll, initialDisplayCount]);
    
    
    const hasMore = keywords?.length > initialDisplayCount;
    
    return (
        <div className='keywords'>
            {displayedKeywords && displayedKeywords.map((keyword, index) => (
                <span key={index} className='keyword-container'>
                    {keyword?.text}
                </span>
            ))}
            {hasMore && (
                <button 
                    className='show-more-btn' 
                    onClick={() => setShowAll(!showAll)}
                >
                    {showAll ? 'Show Less' : `Show More (${keywords.length - initialDisplayCount})`}
                </button>
            )}
        </div>
    );
};

export default React.memo(Keywords);